import { Button, Modal } from 'native-base';
import React, { useState } from 'react';
import { Icon } from '../../Common/components/Icon';
import { faBookMedical } from '@fortawesome/pro-solid-svg-icons/faBookMedical';
import { DoctorMHRMedicinesModal } from './DoctorMHRMedicinesModal';

interface IDoctorMHRMedicinesProps {
  customerID: string;
  onLoadDocumentCLicked: (documentID: string, repositoryID: string | null | undefined) => void;
}
export function DoctorMHRMedicines({ customerID, onLoadDocumentCLicked }: IDoctorMHRMedicinesProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        leftIcon={<Icon icon={faBookMedical} />}
        size={'sm'}
        variant={'outline'}
        onPress={() => setShowModal(true)}
      >
        My Health Record - Medicines View
      </Button>

      <Modal isOpen={showModal} size={'full'} onClose={() => setShowModal(false)}>
        {showModal && <DoctorMHRMedicinesModal customerID={customerID} onLoadDocumentCLicked={onLoadDocumentCLicked} />}
      </Modal>
    </>
  );
}
